export function PageHeader(
  { title, subtitle, action }: { title: string; subtitle?: string; action?: Element },
): Element {
  return (
    <header class="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <small>{subtitle}</small>}
      </div>
      {action}
    </header>
  );
}
